<template>
  <div>
    <!-- Header start -->
    <top-bar></top-bar>
    <header id="header" class="header">
      <navigation />
    </header>
    <!--/ Header end -->
  </div>
</template>

<script>
import TopBar from "@/components/layout/TopBar";
import Navigation from "@/components/layout/Navigation";

export default {
  name: "Header",
  components: {
    TopBar,
    Navigation
  }
};
</script>
